import React from 'react'

import { List, Grid } from "react-virtualized";

import { IconsMind } from "../utils/IconsMind"
import { MaterialIcons } from "../utils/MaterialIcons"
import { FontAwesome } from "../utils/FontAwesome"
import { getIconType, getStandardIcon, getSVGIcon } from './constants/utils';
import ImageUploader from './blocks/editable/ImageUploader';
export default class IconPickerGrid extends React.Component {
  constructor(props){
    super(props)

    let icons = props.type === "iconsmind" ? [...IconsMind, ...FontAwesome] : MaterialIcons
    this.state = {
      icons,
      show: props.show,
      searchTerm: "",
      filteredIcons: icons
    }
  }

  componentWillReceiveProps(nextProps){
    this.setState(nextProps)
  }

  _renderIconImage(icon){
    if(this.props.type === "iconsmind"){
      if(icon.icon.startsWith("fa-")){
        return (
          <i class={`${icon.icon} `}
             style={{
               fontSize: 30,
             }}
          />
        )
      }
      return (
          <i class={`icon icon-${icon.name} color--dark`}
            style={{
              fontSize: 30,
            }}
          />
      )
    }
    else{
      return (
          <i class={`material-icons`}
            style={{
              fontSize: 30,
            }}
          >
            { icon.ligature }
          </i>
      )
    }
  }

  _renderIcon = ({ columnIndex, isScrolling, isVisible, key, parent, rowIndex, style }) => {
    let { filteredIcons } = this.state
    let offset = (rowIndex * 4)
    let icon = filteredIcons[columnIndex + offset]
    if(!icon){
      return <div/>
    }

    return (
      <div
        key={key}
        style={style}
        className="text-center"
      >
        <a onClick={() => this.props.onSelected(icon)} style={{ cursor: 'pointer' }}>
          { this._renderIconImage(icon) }
          <p style={{
            fontSize: 12,
            padding: 8,
            overflow: 'hidden',
            textOverflow: 'ellipsis'
           }}>{ icon.name }</p>
        </a>
      </div>
    );
  };

  render() {
    let {
      show,
      icons,
      searchTerm,
      filteredIcons,
    } = this.state

    return (
      <>
        <div className="form-group">
          <input
            type="text"
            name="search"
            placeholder="Search"
            className="form-control form-control-lg"
            value={searchTerm}
            onChange={e => {
              let searchTerm = e.target.value.toLowerCase()
              filteredIcons = icons.filter(icon => icon.name.toLowerCase().indexOf(searchTerm) > -1)
              this.setState({
                filteredIcons,
                searchTerm
              })
            }}
          />
        </div>

        <div className="icons-grid py-3">

          <Grid
            className={this.props.className}
            cellRenderer={this._renderIcon}
            columnCount={3}
            columnWidth={this.props.columnWidth}
            width={this.props.width}
            height={400}
            rowHeight={this.props.rowHeight}
            rowCount={Math.ceil(filteredIcons.length / 4)}
            overscanRowCount={3}
          />

        </div>
      </>
    )
  }
}

IconPickerGrid.defaultProps = {
    message: null,
    loading: false,
    type: "iconsmind",
    columnWidth : 120,
    width : 390,
    rowHeight : 130,
    className : "r-grid-height"
}

const IconAndSVGPicker = (props) => {
  const {
    type,
    label,
    iconPickerLabel,
    displayIconFontSize,
    displayIconClassName,
    currentIcon,
    iconPickerColumnWidth,
    iconPickerClassName = "",
    iconPickerWidth,
    iconPickerRowHeight,
    onSelected,
    showDefaultIcon,
    defaultIcon,
    hideDisplayIcon,
    iconPickerCancel
  } = props
  const getDisplayIconFontSize = () => {
    let styles = {}
    if (displayIconFontSize !== undefined) {
      styles.fontSize = displayIconFontSize
    }
    return styles
  }
  const iconType = getIconType(currentIcon)

  const iconPickerCancelRenderer = () => {
    if (!iconPickerCancel) return null
    return <div>
      <a
        className="btn btn--primary w-100 mt-4"
        style={{
          color: "white",
          borderColor: "#222",
          backgroundColor: "#222"
        }}
        onClick={() => iconPickerCancel()}
      >
        Cancel
      </a>
    </div>
  }

  return (
    <>
      <br />
      <span>Icon Type</span>
      <select
        value={iconType}
        onChange={(event) => {
          onSelected("type", event.target.value)
        }}
      >
        <option value="standard">Standard</option>
        <option value="svg">SVG</option>
      </select>
      <br/>
      <br/>
      {
        iconType === 'svg' ?
          <>
            <ImageUploader 
              title={""}
              type="svg"
              svgOnly={true}
              src={getSVGIcon(currentIcon) || ""}
              onUploaded={(image) => {
                onSelected("svg", image?.original)
              }}
            />
            {iconPickerCancelRenderer()}
          </>
        :
        <>
          {!hideDisplayIcon && <div className="row no-gutters align-items-center">
            <div className="col-auto">{label} : </div>
            <div className="col-auto pl-2">
              {
                getIconType(currentIcon) === 'svg' ?
                  <img className='m-0' style={getDisplayIconFontSize()} src={getSVGIcon(currentIcon)}  />
                :
                  <>
                    {
                      currentIcon ?
                        <i
                          className={`${getStandardIcon(currentIcon)} ${displayIconClassName}`}
                          style={getDisplayIconFontSize()}
                        />
                      : showDefaultIcon && <span className={displayIconClassName}>{[defaultIcon].map((x) => x)}</span>
                    }
                  </>
              }
            </div>
          </div>}
          {
            iconPickerLabel && <h3>{iconPickerLabel}</h3>
          }
          <div className="button-icon-picker mt-4">
            <IconPickerGrid
              type={type}
              columnWidth={iconPickerColumnWidth}
              className={iconPickerClassName}
              width={iconPickerWidth}
              rowHeight={iconPickerRowHeight}
              onSelected={(icon) => {
                onSelected("standard", icon)
              }}
            />
          </div>
          {iconPickerCancelRenderer()}
        </>
      }
    </>
  )
}

export { IconAndSVGPicker };